import HttpService from "./HttpService";

const WeddingListService = {
  async getList() {
    return HttpService.get("wedding-lists", "", true);
  },

  async createList(listData) {
    return HttpService.post("wedding-lists", listData, true);
  },

  async addItem(itemData) {
    return HttpService.post("wedding-lists/items", itemData, true);
  },

  async removeItem(itemId) {
    return HttpService.delete(`wedding-lists/items/${itemId}`, true);
  },

  async getShareUrl() {
    return HttpService.get("wedding-lists/share-url", "", true);
  },

  async getSharedList(shareCode) {
    return HttpService.get(`wedding-lists/shared/${shareCode}`, "", true);
  },

  async reserveItem(shareCode, itemId) {
    return HttpService.post(
      `wedding-lists/shared/${shareCode}/items/${itemId}/reserve`,
      "",
      true,
    );
  },
};

export default WeddingListService;
